<template>
  <div>
    <div class="visual-reports-stage">
      <div class="row">
        <div class="stage-title">Raporty wizualne</div>
        <hr />
      </div>
      <VisualReportsListView />
    </div>
  </div>
</template>

<script>
import VisualReportsListView from "@/views/ReportsManager/VisualReportsListView.vue";

export default {
  name: "VisualReportsStage",
  components: {
    VisualReportsListView,
  },
};
</script>

<style scoped>
.visual-reports-stage {
  margin-left: 16px;
  margin-right: 16px;
}
</style>
